<template>
  <div class="scan-wrap">
    <div class="info-box">
      <div class="info-line">
        <h4>用户权限：</h4>
        <ul>
          <li>12个月的支持</li>
          <li>5用户访问权限</li>
          <li>无限的Bandwith</li>
        </ul>
      </div>
      <div class="info-line">
        <h4 class="price-label">费用总计：</h4>
        <span class="price">￥{{product.ProductPrice}}</span>
      </div>
    </div>
    <div class="qr-box">
      <h3>扫码支付</h3>
      <div class="img-wrap">
        <p v-if="!qrLink">支付二维码生成中...</p>
        <qrcode-vue v-else :value="qrLink" size="155"></qrcode-vue>
      </div>
      <p>请使用微信扫码支付</p>
    </div>
    <!-- <template v-else>
      <div class="pay-ok-form">
        <img class="ok-img" src="../../assets/rolling.gif" alt>
        <p class="ok-tip">支付中，请稍等</p>
      </div>
    </template>-->
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'scan',
  components: {
    QrcodeVue
  },
  data() {
    return {
      product: this.$store.getters.products[0],
      qrLink: '',
      intervalID: null
      // isLoopOk: false
    }
  },
  methods: {
    getPayQr() {
      this.$store.dispatch('GetProducts').then(res => {
        let productId = ''
        if (res.Data.ProductModels) {
          productId = res.Data.ProductModels[0].ProductId
        }
        this.$store
          .dispatch('GetPayUrl', productId)
          .then(res => {
            this.qrLink = res.Data.PayUrl
            this.longLoopOk(res.Data.out_trade_no)
          })
          .catch(err => {
            this.$router.go(-1)
          })
      })
    },
    longLoopOk(out_trade_no) {
      // this.isLoopOk = true
      this.intervalID = setInterval(() => {
        this.$store
          .dispatch('GetPayResult', out_trade_no)
          .then(res => {
            if (res.Data) {
              this.$router.push({ path: '/pay/pay-ok' })
            }
          })
          .catch(err => {
            this.$router.push({ path: '/pay/pay-lose' })
          })
      }, 1000)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPayQr()
    })
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.intervalID)
    next()
  }
}
</script>
<style lang="less" scoped>
.scan-wrap {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  // align-items: center;
  .info-box {
    margin-top: 30px;
    .info-line {
      display: flex;
      align-items: flex-start;
      margin-bottom: 44px;
      h4 {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        align-self: flex-start;
        margin-right: 17px;
      }
      ul li {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 12px;
        color: #768893;
        text-align: left;
      }
      .price-label {
        align-self: center;
      }
      .price {
        font-size: 40px;
        color: #2c5ac8;
        align-self: center;
      }
    }
  }
  .qr-box {
    font-size: 16px;
    h3 {
      margin-bottom: 17px;
    }
    .img-wrap {
      width: 193px;
      height: 193px;
      border: 1px solid #e6e8ee;
      padding: 18px;
      box-sizing: border-box;
      margin-bottom: 17px;
      img {
        width: 155px;
      }
    }
  }
}
@media screen and (max-width: 990px) {
  .scan-wrap {
    flex-direction: column;
    align-items: center;
    .info-box {
      margin-top: 0;
    }
  }
}
</style>